import {supabase} from '../supabase/supabase';

export const recordOrderCompletionAgreement=async(orderId,metadata={})=>{
  const {data,error}=await supabase.rpc(
    'record_order_completion_agreement_1789600000000',
    {
      p_order_id: orderId,
      p_metadata: metadata
    }
  );

  if (error) throw error;
  return data;
};

export const adminCompleteOrderIfAgreed=async({
  orderId,
  verificationMethod='mutual_party_agreement',
  tokenFingerprint=null,
  securityMetadata={}
})=>{
  const {data,error}=await supabase.rpc(
    'admin_complete_order_if_agreed_1789600000000',
    {
      p_order_id: orderId,
      p_verification_method: verificationMethod,
      p_token_fingerprint: tokenFingerprint,
      p_security_metadata: securityMetadata
    }
  );

  if (error) throw error;
  return data;
};

export const adminFetchOrderCompletionEvents=async()=>{
  const {data,error}=await supabase.rpc(
    'admin_get_order_completion_events_1789600000000'
  );

  if (error) throw error;
  return data || [];
};